import React from 'react';
import {Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';

import {AlertInfo} from '../AlertInfo';
import {StyledAlertSuspended, StyledLink} from './styles';

import {CHAT_V2_DEBT_NEGOTIATION_URL} from 'presentation/constants/chatV2Constants';

const {suspendedIn, regularizeNow} = translations['pt-br'].commons;

function AlertSuspended() {
	return (
		<StyledAlertSuspended
			severity="warning"
			onClick={(event: React.MouseEvent) => {
				event.stopPropagation();
				window.open(CHAT_V2_DEBT_NEGOTIATION_URL);
			}}>
			<AlertInfo.Description>
				<Typography variant="body2">{suspendedIn}</Typography>
				<StyledLink>{regularizeNow}</StyledLink>
			</AlertInfo.Description>
		</StyledAlertSuspended>
	);
}

export {AlertSuspended};
